import { render, staticRenderFns } from "./miniprogram.vue?vue&type=template&id=0f3fbc72"
import script from "./miniprogram.vue?vue&type=script&lang=js"
export * from "./miniprogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports